import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DeleteSession } from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { userLoggedOut } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = Handler;

export const SendDataLayer: HandlerType = props => {
    const session = getSession(props.getState());

    let accountType = "";
    if (session.properties?.isBusinessAccount) {
        accountType = session.properties?.isBusinessAccount.toLowerCase() === "true" ? "Company" : "Personal";
    }

    const state = props.getState();
    userLoggedOut({
        event: 'user_logged_out',
        account_type: accountType,
        'user_id': state.context.session?.userName,
    })
};

addToChainBefore(chain, DeleteSession, SendDataLayer)
